module.exports = __webpack_public_path__ + "img/base_activites_centre_equestre.397ec0ac.svg";